// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* Breakpoints */
.ant-notification {
  z-index: 20000;
}
.collapseRow {
  overflow: hidden;
  transition: 250ms linear;
  transition-property: all;
}
.collapseRow .expandedRowWrapper {
  padding: 0;
}
.table-module__tableOverflow--q73Cb {
  overflow: auto;
  margin: 0 -16px;
  padding: 0 16px;
  position: relative;
}
.table-module__tableWrapper--ZrWtd {
  min-height: 250px;
}
.table-module__tableWrapper--ZrWtd .refetchingIndicator {
  position: fixed;
  bottom: -20px;
  right: 20px;
  color: #1d9333;
  display: flex;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transition: 350ms ease-in-out;
  transition-property: opacity, visibility;
  z-index: 1;
}
.table-module__tableWrapper--ZrWtd .refetchingIndicator.table-module__visible--OIEQH {
  opacity: 1;
  visibility: visible;
}
.table-module__tableWrapper--ZrWtd .loadingWrapper {
  background-color: rgba(255, 255, 255, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 40px;
  color: #1d9333;
  display: flex;
  opacity: 0;
  pointer-events: all;
  visibility: hidden;
  justify-content: center;
  padding-top: 20vh;
  transition: 350ms ease-in-out;
  transition-property: all;
}
.table-module__tableWrapper--ZrWtd .loadingWrapper.table-module__visible--OIEQH {
  opacity: 1;
  visibility: visible;
  pointer-events: none;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY {
  display: grid;
  width: 100%;
  transition: 350ms ease-in-out;
  transition-property: filter;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY.table-module__loadingTable--Rv7Ce {
  filter: blur(4px);
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO {
  display: contents;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO .table-module__headerColumn--F8RVK {
  padding: 12px 12px;
  display: flex;
  font-weight: 500;
  font-size: 13px;
  color: #454545;
  background-color: #005866;
  color: white;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO .table-module__headerColumn--F8RVK.table-module__first--GNwm8 {
  border-top-left-radius: 12px;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO .table-module__headerColumn--F8RVK.table-module__last--KzE6I {
  border-top-right-radius: 12px;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO .table-module__headerColumn--F8RVK.table-module__sortableColumn--WsP7T {
  cursor: pointer;
  user-select: none;
  gap: 6px;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO .table-module__headerColumn--F8RVK.table-module__sortableColumn--WsP7T:hover {
  filter: brightness(1.15);
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO .table-module__headerColumn--F8RVK.table-module__sortedColumn--jhIoZ {
  filter: brightness(1.1);
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO .table-module__headerColumn--F8RVK .table-module__sortIcon--DT2Uz {
  opacity: 0.35;
  font-size: 11px;
  display: flex;
  align-items: center;
  transition: opacity 150ms ease;
}
.table-module__sortableColumn--WsP7T:hover .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO .table-module__headerColumn--F8RVK .table-module__sortIcon--DT2Uz {
  opacity: 0.7;
}
.table-module__sortedColumn--jhIoZ .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO .table-module__headerColumn--F8RVK .table-module__sortIcon--DT2Uz {
  opacity: 1;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq {
  display: contents;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N {
  display: contents;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N .table-module__cellHeader--qcCWQ {
  display: none;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N .table-module__cell--mO54x {
  color: #454545;
  font-size: 13px;
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N .table-module__cell--mO54x.table-module__oddColor--NChJk {
  background-color: #efefef;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq.table-module__clickable--tl71D {
  cursor: pointer;
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq.table-module__clickable--tl71D.table-module__active--dLq_y .table-module__cell--mO54x {
  background-color: rgba(8, 108, 124, 0.2);
}
.table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq.table-module__clickable--tl71D:hover .table-module__cell--mO54x {
  background-color: rgba(8, 108, 124, 0.2);
}
@media only screen and (max-width: 600px) {
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__headerWrapper--l8hVO {
    display: none;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq {
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
    margin-bottom: 16px;
    padding: 16px;
    background-color: #f2f2f2;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N {
    display: flex;
    width: 100%;
    justify-content: space-between;
    border-bottom: 1px solid #f0f0f0;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N.table-module__verticalAlignment--raNSS {
    padding: 16px 0;
    flex-direction: column;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N.table-module__verticalAlignment--raNSS .table-module__cellHeader--qcCWQ {
    justify-content: center;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N:last-child {
    border-bottom: initial;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N:last-child .table-module__cellHeader--qcCWQ {
    display: none;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N:last-child .table-module__cell--mO54x {
    width: 100%;
    justify-content: center;
    padding: 16px 0 0;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N .table-module__cellHeader--qcCWQ {
    display: flex;
    font-size: 13px;
    color: #086c7c;
    align-items: center;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N .table-module__cell--mO54x {
    border-bottom: initial;
  }
  .table-module__tableWrapper--ZrWtd .table-module__table--xsWZY .table-module__row--BhKMq .table-module__cellContent--yma2N .table-module__cell--mO54x.table-module__oddColor--NChJk {
    background-color: initial;
  }
}
.table-module__pagination--taydj {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  align-items: center;
}
.table-module__pagination--taydj .table-module__selectPageSize--SR439 {
  min-width: 100px;
  background-color: transparent;
  margin-left: 16px;
  padding-bottom: 0;
}
.table-module__pagination--taydj .table-module__pageInput--iAbpc {
  width: 64px;
  height: 40px;
  text-align: center;
  margin-left: 8px;
}
.table-module__pagination--taydj .table-module__pageInput--iAbpc > div,
.table-module__pagination--taydj .table-module__pageInput--iAbpc input {
  height: 100%;
}
.table-module__pagination--taydj .table-module__item--QV0LP {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #454545;
  margin-right: 8px;
}
.table-module__pagination--taydj .table-module__item--QV0LP:hover {
  color: white;
  border-color: #454545;
  background-color: #454545;
}
.table-module__pagination--taydj .table-module__item--QV0LP.table-module__isPress--rUGSm {
  cursor: pointer;
  border: 1px solid #454545;
}
.table-module__pagination--taydj .table-module__item--QV0LP.table-module__currentPage--IPbFX {
  color: white;
  border-color: #454545;
  background-color: #454545;
}
.table-module__pagination--taydj .table-module__space--UMEdm {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #454545;
  margin-right: 8px;
  cursor: pointer;
}
.table-module__paginationWrapper--k_mwW {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.table-module__totalCount--ygKSD {
  font-weight: 500;
  font-size: 15px;
  color: #454545;
}
`, "",{"version":3,"sources":["webpack://./components/organisms/table/table.module.less","webpack://./styles/variables.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,gBAAgB;AC0JhB;EACE,cAAA;ADxJF;AALA;EACE,gBAAA;EACA,wBAAA;EACA,wBAAA;AAOF;AAVA;EAMI,UAAA;AAOJ;AAHA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAKF;AAFA;EACE,iBAAA;AAIF;AALA;EAII,eAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,6BAAA;EACA,wCAAA;EACA,UAAA;AAIJ;AAFI;EACE,UAAA;EACA,mBAAA;AAIN;AAtBA;EAuBI,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,6BAAA;EACA,wBAAA;AAEJ;AAAI;EACE,UAAA;EACA,mBAAA;EACA,oBAAA;AAEN;AA7CA;EAgDI,aAAA;EACA,WAAA;EACA,6BAAA;EACA,2BAAA;AAAJ;AAEI;EACE,iBAAA;AAAN;AAtDA;EA0DM,iBAAA;AADN;AAzDA;EA6DQ,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AADR;AAGQ;EACE,4BAAA;AADV;AAIQ;EACE,6BAAA;AAFV;AAKQ;EACE,eAAA;EACA,iBAAA;EACA,QAAA;AAHV;AAKU;EACE,wBAAA;AAHZ;AAOQ;EACE,uBAAA;AALV;AAnFA;EA4FU,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AANV;AAQU;EACE,YAAA;AANZ;AASU;EACE,UAAA;AAPZ;AAhGA;EA8GM,iBAAA;AAXN;AAnGA;EAiHQ,iBAAA;AAXR;AAtGA;EAoHU,aAAA;AAXV;AAzGA;EAwHU,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AAZV;AAcU;EACE,yBAAA;AAZZ;AAiBM;EACE,eAAA;AAfR;AAiBQ;EAEI,wCAAA;AAhBZ;AAoBQ;EAEI,wCAAA;AAnBZ;AA0BE;EAAA;IAEI,aAAA;IACA,sBAAA;IACA,gBAAA;EAxBJ;EAoBA;IAOM,aAAA;EAxBN;EAiBA;IAWM,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,8CAAA;IACA,mBAAA;IACA,aAAA;IACA,yBAAA;EAzBN;EAOA;IAqBQ,aAAA;IACA,WAAA;IACA,8BAAA;IACA,gCAAA;EAzBR;EA2BQ;IACE,eAAA;IACA,sBAAA;EAzBV;EAuBQ;IAKI,uBAAA;EAzBZ;EA6BQ;IACE,sBAAA;EA3BV;EA0BQ;IAII,aAAA;EA3BZ;EAuBQ;IAQI,WAAA;IACA,uBAAA;IACA,iBAAA;EA5BZ;EAjBA;IAkDU,aAAA;IACA,eAAA;IACA,cAAA;IACA,mBAAA;EA9BV;EAvBA;IAyDU,sBAAA;EA/BV;EAiCU;IACE,yBAAA;EA/BZ;AACF;AAuCA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;AArCF;AAiCA;EAOI,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,iBAAA;AArCJ;AA2BA;EAcI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAtCJ;AAqBA;;EAqBM,YAAA;AAtCN;AAiBA;EA0BI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;AAxCJ;AA0CI;EACE,YAAA;EACA,qBAAA;EACA,yBAAA;AAxCN;AA2CI;EACE,eAAA;EACA,yBAAA;AAzCN;AA4CI;EACE,YAAA;EACA,qBAAA;EACA,yBAAA;AA1CN;AAPA;EAsDI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AA5CJ;AAgDA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;AA9CF;AAiDA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AA/CF","sourcesContent":["@import '../../../styles/variables.less';\n\n:global(.collapseRow) {\n  overflow: hidden;\n  transition: 250ms linear;\n  transition-property: all;\n\n  :global(.expandedRowWrapper) {\n    padding: 0;\n  }\n}\n\n.tableOverflow {\n  overflow: auto;\n  margin: 0 -16px;\n  padding: 0 16px;\n  position: relative;\n}\n\n.tableWrapper {\n  min-height: 250px;\n\n  :global(.refetchingIndicator) {\n    position: fixed;\n    bottom: -20px;\n    right: 20px;\n    color: @green-400;\n    display: flex;\n    opacity: 0;\n    pointer-events: none;\n    visibility: hidden;\n    transition: 350ms ease-in-out;\n    transition-property: opacity, visibility;\n    z-index: 1;\n\n    &.visible {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n  :global(.loadingWrapper) {\n    background-color: rgba(255, 255, 255, 0.3);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding: 40px;\n    color: @green-400;\n    display: flex;\n    opacity: 0;\n    pointer-events: all;\n    visibility: hidden;\n    justify-content: center;\n    padding-top: 20vh;\n    transition: 350ms ease-in-out;\n    transition-property: all;\n\n    &.visible {\n      opacity: 1;\n      visibility: visible;\n      pointer-events: none;\n    }\n  }\n\n  .table {\n    display: grid;\n    width: 100%;\n    transition: 350ms ease-in-out;\n    transition-property: filter;\n\n    &.loadingTable {\n      filter: blur(4px);\n    }\n\n    .headerWrapper {\n      display: contents;\n\n      .headerColumn {\n        padding: 12px 12px;\n        display: flex;\n        font-weight: 500;\n        font-size: 13px;\n        color: @text-color;\n        background-color: @table-header-color;\n        color: white;\n\n        &.first {\n          border-top-left-radius: 12px;\n        }\n\n        &.last {\n          border-top-right-radius: 12px;\n        }\n\n        &.sortableColumn {\n          cursor: pointer;\n          user-select: none;\n          gap: 6px;\n\n          &:hover {\n            filter: brightness(1.15);\n          }\n        }\n\n        &.sortedColumn {\n          filter: brightness(1.1);\n        }\n\n        .sortIcon {\n          opacity: 0.35;\n          font-size: 11px;\n          display: flex;\n          align-items: center;\n          transition: opacity 150ms ease;\n\n          .sortableColumn:hover & {\n            opacity: 0.7;\n          }\n\n          .sortedColumn & {\n            opacity: 1;\n          }\n        }\n      }\n    }\n\n    .row {\n      display: contents;\n\n      .cellContent {\n        display: contents;\n\n        .cellHeader {\n          display: none;\n        }\n\n        .cell {\n          color: @text-color;\n          font-size: 13px;\n          display: flex;\n          align-items: center;\n          padding: 10px 12px;\n          border-bottom: 1px solid @separator;\n\n          &.oddColor {\n            background-color: @oddColor;\n          }\n        }\n      }\n\n      &.clickable {\n        cursor: pointer;\n\n        &.active {\n          .cell {\n            background-color: fadeout(@label-color, 80%);\n          }\n        }\n\n        &:hover {\n          .cell {\n            background-color: fadeout(@label-color, 80%);\n          }\n        }\n      }\n    }\n  }\n\n  @media @mobileXL {\n    .table {\n      display: flex;\n      flex-direction: column;\n      margin-top: 20px;\n\n      .headerWrapper {\n        display: none;\n      }\n\n      .row {\n        display: flex;\n        flex-direction: column;\n        border-radius: 8px;\n        overflow: hidden;\n        box-shadow: @v2-bg-card-mobile-shadow;\n        margin-bottom: 16px;\n        padding: 16px;\n        background-color: darken(white, 5%);\n\n        .cellContent {\n          display: flex;\n          width: 100%;\n          justify-content: space-between;\n          border-bottom: 1px solid @separator;\n\n          &.verticalAlignment {\n            padding: 16px 0;\n            flex-direction: column;\n\n            .cellHeader {\n              justify-content: center;\n            }\n          }\n\n          &:last-child {\n            border-bottom: initial;\n\n            .cellHeader {\n              display: none;\n            }\n\n            .cell {\n              width: 100%;\n              justify-content: center;\n              padding: 16px 0 0;\n            }\n          }\n\n          .cellHeader {\n            display: flex;\n            font-size: 13px;\n            color: @label-color;\n            align-items: center;\n          }\n\n          .cell {\n            border-bottom: initial;\n\n            &.oddColor {\n              background-color: initial;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 16px;\n  align-items: center;\n\n  .selectPageSize {\n    min-width: 100px;\n    background-color: transparent;\n    margin-left: 16px;\n    padding-bottom: 0;\n  }\n\n  .pageInput {\n    width: 64px;\n    height: 40px;\n    text-align: center;\n    margin-left: 8px;\n\n    > div,\n    input {\n      height: 100%;\n    }\n  }\n\n  .item {\n    width: 30px;\n    height: 30px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: @text-color;\n    margin-right: 8px;\n\n    &:hover {\n      color: white;\n      border-color: @text-color;\n      background-color: @text-color;\n    }\n\n    &.isPress {\n      cursor: pointer;\n      border: 1px solid @text-color;\n    }\n\n    &.currentPage {\n      color: white;\n      border-color: @text-color;\n      background-color: @text-color;\n    }\n  }\n\n  .space {\n    width: 30px;\n    height: 30px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: @text-color;\n    margin-right: 8px;\n    cursor: pointer;\n  }\n}\n\n.paginationWrapper {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.totalCount {\n  font-weight: 500;\n  font-size: 15px;\n  color: @text-color;\n}\n","@import '~antd/lib/style/themes/default.less';\n@import './breakpoints.less';\n\n// Font\n@font-family: 'Roboto', 'Oswald', BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n  'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n  'Noto Color Emoji';\n\n// Color palette\n// Cores Primárias\n@primary-100: #91cc92;\n@primary-200: #67bf65;\n@primary-300: #3cb638;\n@primary-400: #2d8d2c;\n@primary-500: #1B752B; // Cor original\n@primary-600: #165e25;\n@primary-700: #10461f;\n@primary-800: #0b2f19;\n@primary-900: #051912;\n\n// Cores Secundárias\n@secondary-100: #90a8d4;\n@secondary-200: #668bc1;\n@secondary-300: #3d6eaf;\n@secondary-400: #2f5c9f;\n@secondary-500: #2B4675; // Cor original\n@secondary-600: #23405e;\n@secondary-700: #1b3948;\n@secondary-800: #122a31;\n@secondary-900: #091c1b;\n\n// Cores Terciárias\n@tertiary-100: #d48f90;\n@tertiary-200: #c16667;\n@tertiary-300: #af3e3f;\n@tertiary-400: #9f2d2f;\n@tertiary-500: #752B1B; // Cor original\n@tertiary-600: #5e2424;\n@tertiary-700: #46201b;\n@tertiary-800: #2f180f;\n@tertiary-900: #1c0c05;\n\n// Cores de Erro\n@error-100: #d49090;\n@error-200: #c16767;\n@error-300: #af3f3f;\n@error-400: #9f2e2e;\n@error-500: #751B2B; // Cor original\n@error-600: #5e2424;\n@error-700: #461e1e;\n@error-800: #2f1515;\n@error-900: #1c0909;\n\n// Cores de Aviso\n@warning-100: #d4d490;\n@warning-200: #c1c167;\n@warning-300: #afaf3f;\n@warning-400: #9f9f2d;\n@warning-500: #75751B; // Cor original\n@warning-600: #5e5e15;\n@warning-700: #46461e;\n@warning-800: #2f2f15;\n@warning-900: #1c1c09;\n\n// Cores de Informação\n@info-100: #90d4d4;\n@info-200: #67c1c1;\n@info-300: #3fafaf;\n@info-400: #2d9f9f;\n@info-500: #1B7575; // Cor original\n@info-600: #155e5e;\n@info-700: #0f4646;\n@info-800: #092f2f;\n@info-900: #051c1c;\n\n// Cinza\n@gray-100: #d4d4d4;\n@gray-200: #c1c1c1;\n@gray-300: #afafaf;\n@gray-400: #9f9f9f;\n@gray-500: #757575; // Cor original\n@gray-600: #5e5e5e;\n@gray-700: #464646;\n@gray-800: #2f2f2f;\n@gray-900: #1c1c1c;\n\n\n// Colors\n@v2-color-primary: rgb(144, 213, 221);\n@v2-color-secondary: #72bc75;\n@green-300: rgb(137, 235, 155);\n@green-400: rgb(29, 147, 51);\n@green-500: rgb(27, 117, 43);\n@red-500: rgb(128,0,0);\n@red-400: #B00020;\n@red-300: #f77777;\n@yellow-500: rgb(204, 148, 74);\n\n@font-size-mobile: 13px;\n@font-size-base: 13px;\n\n@title-font-size: 32px;\n@title-color: @green-500;\n\n@separator: #f0f0f0;\n@oddColor: #efefef;\n\n@subtitle-font-size: 22px;\n@subtitle-color: rgb(0, 65, 75);\n\n@bg-menu-lateral: rgb(0, 65, 75);\n@icon-menu-sup-color: rgb(61, 197, 86);\n@label-color: rgb(8, 108, 124);\n\n@header-color: #005866;\n@table-header-color: #005866;\n\n// Shadows\n@v2-bg-card-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);\n@v2-bg-label-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);\n@v2-bg-overlay-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);\n@v2-bg-card-mobile-shadow: 0px 0px 5px 0px rgba(0,0,0,0.30);\n\n// Backgrounds\n@bg-color: #ffffff;\n\n// Text colors\n@text-color: #454545;\n@input-color: #333;\n\n// Dev colors\n@dev-background: #444;\n@dev-button-hover: #222;\n@v2-bg-card: rgba(255,255,255,0.1);\n\n\n\n// Sizes\n@header-height: 60px;\n@menu-width: 200px;\n\n// V2\n@v2-bg-color: #222629;\n\n\n@bg-card: #37393B;\n@dashboard-page: lighten(@bg-color, 20%);\n\n// Titles\n@v2-menu-title: #ddd;\n\n// Menu\n@v2-text-color: @text-color;\n@v2-text-color-hover: #ccc;\n\n// Animations\n@animation-time: 450ms;\n\n:global(.ant-notification) {\n  z-index: 20000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ant-notification": `ant-notification`,
	"antNotification": `ant-notification`,
	"collapseRow": `collapseRow`,
	"expandedRowWrapper": `expandedRowWrapper`,
	"tableOverflow": `table-module__tableOverflow--q73Cb`,
	"tableWrapper": `table-module__tableWrapper--ZrWtd`,
	"refetchingIndicator": `refetchingIndicator`,
	"visible": `table-module__visible--OIEQH`,
	"loadingWrapper": `loadingWrapper`,
	"table": `table-module__table--xsWZY`,
	"loadingTable": `table-module__loadingTable--Rv7Ce`,
	"headerWrapper": `table-module__headerWrapper--l8hVO`,
	"headerColumn": `table-module__headerColumn--F8RVK`,
	"first": `table-module__first--GNwm8`,
	"last": `table-module__last--KzE6I`,
	"sortableColumn": `table-module__sortableColumn--WsP7T`,
	"sortedColumn": `table-module__sortedColumn--jhIoZ`,
	"sortIcon": `table-module__sortIcon--DT2Uz`,
	"row": `table-module__row--BhKMq`,
	"cellContent": `table-module__cellContent--yma2N`,
	"cellHeader": `table-module__cellHeader--qcCWQ`,
	"cell": `table-module__cell--mO54x`,
	"oddColor": `table-module__oddColor--NChJk`,
	"clickable": `table-module__clickable--tl71D`,
	"active": `table-module__active--dLq_y`,
	"verticalAlignment": `table-module__verticalAlignment--raNSS`,
	"pagination": `table-module__pagination--taydj`,
	"selectPageSize": `table-module__selectPageSize--SR439`,
	"pageInput": `table-module__pageInput--iAbpc`,
	"item": `table-module__item--QV0LP`,
	"isPress": `table-module__isPress--rUGSm`,
	"currentPage": `table-module__currentPage--IPbFX`,
	"space": `table-module__space--UMEdm`,
	"paginationWrapper": `table-module__paginationWrapper--k_mwW`,
	"totalCount": `table-module__totalCount--ygKSD`
};
export default ___CSS_LOADER_EXPORT___;
